import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DialogService } from '../../../shared/standalone-packages/dialog/services/dialog.service';
import { SCConfig } from '../../../sc-config/constant/sc-config.constant';
import { BusinessService } from '../../services/business.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-app-traning-voting',
    templateUrl: './app-traning-voting.component.html',
    styleUrls: ['./app-traning-voting.component.scss'],
    standalone: false
})
export class AppTraningVotingComponent implements OnInit, OnDestroy {
    service: any;
    @Input() set serviceInfo(val) {
        this.service = val;
        this.initParashitTraningForm();
    }
    public ckEditorConfig = SCConfig.CKEditorConfigH90;
    @Input() isFromDetails: boolean = false;
    @Input() caseServiceForm: FormGroup;
    parashiftTrainingForm: FormGroup;
    parashiftTrainingVotingOption = SCConfig.ParashiftTrainingVotingOption;
    @Input() caseId: string;
    isSavedTrainingVoting: boolean = false;
    @Output() parashiftVotingDone = new EventEmitter<any>();
    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(
        private fb: FormBuilder,
        private dialogService: DialogService,
        private businessService: BusinessService
    ) {}

    ngOnInit(): void {
        this.initParashitTraningForm();
    }

    initParashitTraningForm() {
        if (this.isFromDetails) {
            this.parashiftTrainingForm = this.fb.group({
                ServiceItemId: [this.service && this.service.ServiceItem && this.service.ServiceItem.ServiceItemId],
                Vote: [
                    (this.service && this.service.ParashiftTraining && this.service.ParashiftTraining.Vote) ||
                        this.parashiftTrainingVotingOption[1].Value
                ],
                Comment: [this.service && this.service.ParashiftTraining && this.service.ParashiftTraining.Comment]
            });
        } else {
            const service = (this.caseServiceForm && this.caseServiceForm.getRawValue()) || {};
            this.parashiftTrainingForm = this.fb.group({
                ServiceItemId: [service && service.ServiceItem && service.ServiceItem.ServiceItemId],
                Vote: [
                    (service && service.ParashiftTraining && service.ParashiftTraining.Vote) ||
                        this.parashiftTrainingVotingOption[1].Value
                ],
                Comment: [service && service.ParashiftTraining && service.ParashiftTraining.Comment]
            });
        }
    }
    saveVoting() {
        this.isSavedTrainingVoting = true;
        if (!this.isFromDetails) {
            let parashiftTraining = this.caseServiceForm.get('ParashiftTraining') as FormGroup;
            const parashiftTrainingValue = this.parashiftTrainingForm.getRawValue();
            parashiftTraining.get('ServiceItemId').setValue(parashiftTrainingValue.ServiceItemId);
            parashiftTraining.get('Vote').setValue(parashiftTrainingValue.Vote);
            parashiftTraining.get('Comment').setValue(parashiftTrainingValue.Comment);
            this.dialogService.closeModal();
        } else {
            const parashiftTrainingValue = this.parashiftTrainingForm.getRawValue();
            const payload = {
                CaseId: this.caseId,
                ParashiftTraining: [...parashiftTrainingValue]
            };
            this.businessService
                .updateParashiftTrainingVote(payload)
                .pipe(takeUntil(this.destroy$))
                .subscribe(
                    res => {
                        this.isSavedTrainingVoting = false;
                        this.parashiftVotingDone.emit(true);
                        this.onModalClose();
                    },
                    error => {
                        console.error('Error => ', error);
                        this.isSavedTrainingVoting = false;
                        this.parashiftVotingDone.emit(false);
                        this.onModalClose();
                    }
                );
        }
    }

    onModalClose() {
        this.dialogService.closeModal();
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
